var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lock-icon',{attrs:{"fillColor":"#b32a2a","size":50}}),_c('span',{staticClass:"unauthorized-text"},[_vm._v("Não autorizado!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }